import { useSetRecoilState } from 'recoil';
import { loadingOverlayAtom } from './atoms';

const useLoadingOverlay = () => {
  const setLoadingOverlay = useSetRecoilState(loadingOverlayAtom);

  const showLoadingOverlay = () => {
    setLoadingOverlay({
      isOpen: true
    });
  };

  const hideLoadingOverlay = () => {
    setLoadingOverlay({
      isOpen: false
    });
  };

  return { showLoadingOverlay, hideLoadingOverlay };
};

export { useLoadingOverlay };
